import { useRef, useState } from 'react'

import Image from 'next/image'

import useIsomorphicEffect from '@hooks/useClientSideLayoutEffect'

import DialogPointer from './pointer.svg'

import styles from './dialog.module.scss'

type DialogProps = {
  text: string
}

export default function Dialog({ text }: DialogProps): JSX.Element {
  const ref = useRef<HTMLDivElement>(null)
  const [diff, setDiff] = useState<number>(0)

  /**
   * @description Prevent tooltip dialog overflow.
   *
   * Using useLayoutEffect (isomorphic) in order to apply the
   * css tweak before the rendering
   *
   * @todo implement vertical overflow
   *
   */
  useIsomorphicEffect(() => {
    const rect = ref.current?.getClientRects()

    const left = rect?.[0].x || 0
    const width = rect?.[0].width || 0

    const delta = left + width + 10 - window.innerWidth

    if (delta > 0) {
      setDiff(-delta - 30)
    } else if (left < 0) {
      setDiff(-left + 10)
    }

    return () => {
      setDiff(0)
    }
  }, [setDiff])

  return (
    <div className={styles.dialog} style={{ left: diff }} ref={ref} role="tooltip">
      <Image
        src={DialogPointer}
        alt="dialog pointer"
        className={styles.pointer}
        style={{ left: `calc(50% - ${diff}px)` }}
      />
      {text}
    </div>
  )
}
